import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enJson from "@/locales/en.json";
import ruJson from "@/locales/ru.json";

if (!i18next.isInitialized) {
  void i18next.use(initReactI18next).init({
    lng: localStorage.getItem("lang") ?? "ru",
    fallbackLng: "ru",
    resources: {
      en: { translation: enJson },
      ru: { translation: ruJson },
    },
    interpolation: {
      escapeValue: false,
    },
  });
}

export default i18next;
